export const initStateDashboard = (
    Object.assign({
      data_way_payments   : [],
      data_customers      : [],
      data_type_documents : [],
      customers_page      : 0
    })
 );